import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api, unwrap } from "../../lib/api";
import { canEdit, useMe } from "../../lib/me";
import { formatTime } from "../../lib/time";
import { Badge } from "../../ui/Badge";
import { Button } from "../../ui/Button";
import { Empty } from "../../ui/Empty";
import { CreateActionDialog } from "./CreateActionDialog";
import { KindBadge } from "./KindBadge";
import { STATUS_TONE } from "./status-tone";

export function ActionsPage() {
  const { t } = useTranslation();
  const me = useMe();
  const [creating, setCreating] = useState(false);
  const actions = useQuery({ queryKey: ["actions"], queryFn: () => unwrap(api.actions.$get()) });
  const mayCreate = me.memberships.some((m) => canEdit(m.role));

  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-4 p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold">{t("actions.title")}</h1>
        {mayCreate && (
          <Button variant="primary" onClick={() => setCreating(true)}>
            <Plus size={16} /> {t("actions.create")}
          </Button>
        )}
      </div>
      {actions.data?.length === 0 && <Empty>{t("actions.empty")}</Empty>}
      <ul className="divide-y divide-zinc-800 rounded-lg border border-zinc-800">
        {actions.data?.map((a) => (
          <li key={a.id}>
            {/* Phone: a card — the name on its own full-width line, badges and date below. Desktop
                (sm+): the old single row (#290). */}
            <Link
              to="/actions/$actionId"
              params={{ actionId: a.id }}
              className="flex flex-col gap-2 px-4 py-3 hover:bg-zinc-900 sm:flex-row sm:items-center sm:gap-3"
            >
              <span className="min-w-0 font-medium sm:truncate">{a.name}</span>
              <div className="flex flex-wrap items-center gap-2 sm:contents">
                <KindBadge kind={a.kind} />
                <Badge tone={STATUS_TONE[a.status]}>{t(`actionStatus.${a.status}`)}</Badge>
                <span className="whitespace-nowrap text-xs text-zinc-500 sm:ml-auto sm:shrink-0">
                  {new Date(a.createdAt).toLocaleDateString("pl-PL")} {formatTime(a.createdAt)}
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <CreateActionDialog open={creating} onClose={() => setCreating(false)} />
    </div>
  );
}
